import { useState } from 'react';
import { NavLink } from 'react-router';
import {
    AppBar,
    Toolbar,
    Container,
    Box,
    Typography,
    IconButton,
    Drawer,
    List,
    ListItem,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const links = [
    { to: '/', label: 'Úvod', end: true },
    { to: '/o-mne', label: 'O mně' },
    { to: '/psychoterapie', label: 'Psychoterapie' },
    { to: '/etopedicke-poradenstvi', label: 'Etopedické poradenství' },
    { to: '/kontakt', label: 'Kontakt' },
];

export function Header() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                bgcolor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(6px)',
                borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
                transition: 'all 0.3s ease',
            }}
        >
            <Container maxWidth="lg">
                <Toolbar
                    disableGutters
                    sx={{
                        minHeight: { xs: 64, md: 72 },
                        justifyContent: 'space-between',
                    }}
                >
                    {/* Logo */}
                    <Typography
                        variant="h6"
                        component={NavLink}
                        to="/"
                        sx={{
                            fontWeight: 600,
                            fontSize: { xs: '1.1rem', md: '1.25rem' },
                            color: 'text.primary',
                            textDecoration: 'none',
                            transition: 'color 0.2s ease',
                            '&:hover': { color: 'primary.dark' },
                        }}
                    >
                        Mgr. Hana Jarkovská
                    </Typography>

                    {/* Desktop Menu */}
                    {!isMobile && (
                        <Box
                            component="nav"
                            sx={{
                                display: 'flex',
                                gap: 4,
                                alignItems: 'center',
                            }}
                        >
                            {links.map((link) => (
                                <Typography
                                    key={link.to}
                                    component={NavLink}
                                    to={link.to}
                                    end={link.end}
                                    sx={{
                                        fontSize: '0.95rem',
                                        fontWeight: 500,
                                        letterSpacing: '1px',
                                        color: 'text.secondary',
                                        textDecoration: 'none',
                                        position: 'relative',
                                        pb: 0.5,
                                        transition: 'color 0.2s ease',
                                        '&:hover': { color: 'text.primary' },
                                        '&.active': {
                                            color: 'primary.dark',
                                            '&::after': {
                                                content: '""',
                                                position: 'absolute',
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                height: 2,
                                                bgcolor: 'primary.dark',
                                            },
                                        },
                                    }}
                                >
                                    {link.label}
                                </Typography>
                            ))}
                        </Box>
                    )}

                    {/* Mobile Menu Button */}
                    {isMobile && (
                        <IconButton
                            color="inherit"
                            aria-label="open menu"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{ color: 'text.primary' }}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                </Toolbar>
            </Container>

            {/* Mobile Drawer */}
            <Drawer
                anchor="right"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: 280,
                        bgcolor: 'background.paper',
                        p: 3,
                    },
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
                    <IconButton onClick={handleDrawerToggle} sx={{ color: 'text.primary' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <List sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {links.map((link) => (
                        <ListItem key={link.to} disablePadding>
                            <Typography
                                component={NavLink}
                                to={link.to}
                                end={link.end}
                                onClick={handleDrawerToggle}
                                sx={{
                                    width: '100%',
                                    fontSize: '1.1rem',
                                    fontWeight: 500,
                                    letterSpacing: '1px',
                                    color: 'text.secondary',
                                    textDecoration: 'none',
                                    py: 1.5,
                                    px: 2,
                                    borderRadius: 1,
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        bgcolor: 'primary.light',
                                        color: 'text.primary',
                                    },
                                    '&.active': {
                                        bgcolor: 'primary.main',
                                        color: 'primary.contrastText',
                                    },
                                }}
                            >
                                {link.label}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </AppBar>
    );
}
